       
//{{-- all "global" variables pertaining to projcreateform are prefixed by pjc_   --}}        
var pjc_DocArr = [];                                                                        //{{-- pjc_DocArr receives a copy of create.blade's docArr --}}
var pjc_totalcost = 0;  
var pjc_filesToUpload = 0;        
var pjc_filesUploaded = 0;
var pjc_fileTransferParams = [];

//{{-- ========================================================================================== --}}
//{{-- Scripts directly triggered by form elements                                                --}}
//{{-- ========================================================================================== --}}
$(function(){

    //{{-- Processes the saveProjectBtn button click --}}
    $('#saveProjectBtn').safeOn('click', function(evt) {                                 
        evt.stopImmediatePropagation();                                                     //{{-- Prevent click event triggering once for every parent container --}}
        //{{-- Make sure all the necessary fields are there --}}
        if ( !$("[name='description']").val() ) {
            $("#description-error").html(pjc_description_please);                           //{{-- pjc_ variable defined in projectcreateform blade --}}
        } else {
            $('[id$="error"]').html("");                                                    //{{-- Clear all error fields --}}
            $(".progress-bar").html("");                                                    //{{-- Reset the progress bar --}}
            pjc_filesToUpload = countFilesToUpload(pjc_DocArr);                             //{{-- Set counters --}}
            if (pjc_filesToUpload > 0) {
                $('#saveProjectBtn').prop("disabled", true);
                pjc_filesUploaded = 0;
                uploadFiles(pjc_DocArr, pjc_fileTransferParams, "original");                //{{-- uploadFiles is in filedropform --}}
                //{{-- The project (and documents) save will be called from uploadDoneCallback, which calls trackUploads in here... --}}
            }
        }
    });                          

    //{{-- Processes the cancelProjectSaveButn --}}            
    $('#cancelProjectSaveBtn').safeOn('click', function () {
        $('#modalSaveProject').modal('hide');  
        clearProjModalForm();
    });

    //{{-- Monitor our custom event that gets triggered when there's an upload error --}}
    //{{-- Show the file and error message on the modal, change the save button to a cancel button --}}
    $('body').safeOn('myUploadErrorEvent', function (evt, type, fname, errorMsg, callerPrefix) {
        $("#saveProjectBtn").hide();
        $("#cancelProjectSaveBtn").show();
        $("#"+callerPrefix+"-error-msg-div").show();
        msg_upload_error_try_again = eval(callerPrefix + "_upload_error_try_again");
        if (type == "file") {
            //{{-- File-specific upload error --}}
            $("#"+callerPrefix+"-error-msg-title").html(msg_upload_error_try_again);
            $("#"+callerPrefix+"-error-msg-detail").append(fname + "<br />" + "error: " + errorMsg + "<br>");
        } else {
            //{{-- General upload error - THIS CAN BE IGNORED, THE ERRORS BY FILE ARE ENOUGH --}}
            $("#"+callerPrefix+"-error-msg-title").html(msg_upload_error_try_again);
            $("#"+callerPrefix+"-error-msg-detail").append(fname + "<br /> - error: " + errorMsg + "<br>");                    
        }
    });

});

//{{-- ========================================================================================== --}}
//{{-- Scripts to open and close the modal dialog                                                 --}}
//{{-- ========================================================================================== --}}

//{{-- Receives docs and cost and opens the modal form - through checkLogin() --}}
//{{-- Arrays ('cause they're objects) in Javascript are passed by "sharing", which means they are passed by reference, you just can't overwrite (destroy) them completely, but you can change their contents --}}
window.openProjModalForm = function(documentsArr, total) {
    //{{-- Make sure the form is clean --}}
    clearProjModalForm();            
    //{{-- Receive docArr and total cost --}}
    pjc_totalcost = total;
    pjc_DocArr = documentsArr;      
    //{{-- Make sure user is logged in; this will call openModal --}}
    checkLogin();
}

//{{-- Finishes opening the modal --}}
function openModal() {
    var user_id = $("#user_id").val();
    //{{-- Clear the error messages on the form fields (only the description field has one, as it is the only required field): --}}
    var fieldMsg = $('[id$="error"]').html("");
    //{{-- Get the plural and cost strings right --}}
    var filesStr = pjc_DocArr.length > 1 ? pjc_files_upper : pjc_file_upper;    //{{-- variables defined in the projcreateform blade --}}
    var costStr = pjc_total_cost_monetary;                                      //{{-- variable  defined in the projcreateform blade --}}
    //{{-- Get the user's name and email address - AJAX call --}}
    $.get("/getUser", {id: user_id}, function(data) {
        $('[name="responsible"]').val(data[0].name);
        $('[name="notification_email"]').val(data[0].email + "; ");
    });
    //{{-- Get S3 and other file transfer parameters from server when the modal is shown --}}
    getFTParams();
    //{{-- Load the abc select fields, if any --}}
    loadACBRCASelects(user_id);
    //{{-- Put in the summary information: --}}
    $('#summary').val(pjc_DocArr.length + " " + filesStr + " - " + costStr + pjc_totalcost);
    //{{-- Open the modal and prevent 'clicking on the background' from closing it --}}            
    $("#modalSaveProject").modal({backdrop: 'static'}) ;            
}

//{{-- Closes the form, clears and restores fields first --}}
function clearProjModalForm () { 
    pjc_DocArr = []; 
    //{{-- Clear all fields --}}
    var allfields = $(':input:not([name="billto"])','#modalSaveProject');                   //{{-- Select all fields here, but We don't want to turn off the billto checked button... --}}
    allfields.val('');                                                                      //{{-- These are not all stringed because the order matters --}}
    allfields.not(':button, :submit, :reset, :hidden, :radio');
    allfields.prop('checked', false);                                     
    allfields.prop('selected', false);
    //{{-- Fix buttons and message areas --}}
    $("#saveProjectBtn").show();
    $('#saveProjectBtn').prop("disabled", false); 
    $("#cancelProjectSaveBtn").hide();
    $("#progress-div").hide();
    $(".progress-bar").html("");
    $("#pjc-error-msg-div").hide();
    $("#pjc-error-msg-title").html("");
    $("#pjc-error-msg-detail").html("");            
    $('#authNoQuote').prop("checked", true);                                                //{{-- Set the default for the authorization radio button --}}            
} 

//{{-- ========================================================================================== --}}
//{{-- Scripts to handle user login                                                               --}}
//{{-- ========================================================================================== --}}

//{{-- Checks whether user is logged in - opens loginmodal or proceeds to open projcreate modal --}}
function checkLogin() {
    if ( $("#user_id").val() > 0) {
        //{{-- User is logged in, open the project modal --}}
        openModal();
    } else {
        //{{-- Ask user to log in --}}
        //{{-- Set the login callback function, so if the user logs in we will not redirect him to home again --}}
        //{{-- loginCallback is a global variable defined in navbarmain.blade - This will be called by login.blade window['loginCallback'](data); after a successful Ajax login --}}
        loginCallback = function (data) {                                                   //{{-- We can use data if we want to... for now, just check login again so the modal will open --}}
            $("#user_id").val(data.user.id);
            $("#usr_name").val(data.user.name);
            checkLogin();                
        };                
        //{{-- Open the login modal and prevent 'clicking on the background' from closing it --}}
        $("#modallogin").modal();//{backdrop: 'static'});                   
    }
}

//{{-- ========================================================================================== --}}
//{{-- Scripts to deal with the uploaded files                                                    --}}
//{{-- ========================================================================================== --}}

//{{-- Count how many files there are to upload --}}
function countFilesToUpload(docsArr) {
    count = 0;
    $.each(docsArr, function(index, file) {
        if (file.validated && isThere(file.fileData)) count ++;
    });
    return count;
}

//{{-- Get S3 and other file transfer parameters from server --}}
function getFTParams() {
    $.get(pjc_route_to_S3Details, function(s3FormInput) {                                   //{{-- pjc_route_to_S3Details variable  defined in the projcreateform blade --}}
        pjc_fileTransferParams = s3FormInput;
        pjc_fileTransferParams['callerPrefix'] = 'pjc';
    });
}

//{{-- This is called from create.blade.uploadDoneCallback every time jquery file upload finishes uploading a file (in filedropform.blade) --}}
//{{-- This gets called once for each file uploaded - and "file" is not a real file, it only contains the relativePath --}}        
window.trackUploads = function(fileNbr, relativePath, fileSize) {
    if (relativePath) {
        //{{-- Successful upload of one file to S3, now tell server to send it to IPHotel --}}
        //{{-- At this point the file is confirmed to be on S3, so this call to movefilefromS3 shouldn't really fail --}}
        //{{-- If it does fail, we will check for the file's existence in the JMS when the admin first opens the job. --}}
        let url = pjc_route_copyfile;                                                       //{{-- Route to FileController's copyFileFromTMSS3ToLocal method --}}
        let formdata = { path : relativePath, size : fileSize };
        $.post(url, formdata, function(data, status){
            if (isThere(data)) {
                popovermsgbox_open('Error', data, 0, 'OK');
            } else {
                //{{-- On successful copy from S3 to local storage, let's save the project --}}
                //{{-- Make sure we have the uploaded file's path in the right place--}}
                //{{-- var index = pjc_DocArr.findIndex(function(pjc_DocArr) {return pjc_DocArr["filenbr"] === fileNbr} ); --}}  
                //{{-- find filenbr = docNbr in pjc_DocArr --}}
                var index =  myFindIndex(pjc_DocArr, "filenbr", fileNbr);                           //{{-- IE doesn't support array.findIndex, so we implement our own - in main.blade --}}
                pjc_DocArr[index].uploadedPath = relativePath;
        
                //{{-- Keep track of how many files were uploaded --}}
                pjc_filesUploaded++;
                if (pjc_filesUploaded >= pjc_filesToUpload) {
                    title = pjc_files_uploaded;
                    message = pjc_files_uploaded + ": " + pjc_filesUploaded +"<br><br>" + pjc_saving_project_please_wait + "..." ;
                    popovermsgbox_open(title, message, 0, 'NoButtons');
                    saveProject();                                                                  //{{-- Saves the project and its documents --}}
                    pjc_filesToUpload = 0;
                    pjc_filesUploaded = 0;                                      //{{-- we're done uploading, so let's reset the counters, just to be tidy --}}
                }
            }
        });
    }
}

//{{-- ========================================================================================== --}}
//{{-- Scripts to save the project to the database                                                --}}
//{{-- ========================================================================================== --}}

function saveProject() {
    var projArr = [];                                                                       //{{-- the project data for saving --}}            
    var docsArr = [];                                                                       //{{-- the documents data for saving --}}  

    if (! $("#user_id").val() ) {
        //{{-- THIS SHOULD ***NEVER*** HAPPEN --}}
        alert(pjc_pls_login_first);
    } else {
        if (pjc_DocArr.length < 1) {
            //{{-- THIS SHOULD ***NEVER*** HAPPEN EITHER --}}
            alert(pjc_error_no_files);
        } else {
            //{{-- Figure out the correct initial project status: 10 "Received" or 110 "Quote" --}}
            projstatus = $("input[name='authorization']:checked").attr('val') == 0 ? 10 : 110;
            //{{-- Make sure none of the key columns in the table will be set to null --}}
            projaccount  = $("select[name='slAccount']").val() ? $("select[name='slAccount']").val() : 0;
            projbrand    = $("select[name='slBrand']").val() ? $("select[name='slBrand']").val() : 0;
            projcampaign = $("select[name='slCampaign']").val() ? $("select[name='slCampaign']").val() : 0;
            billtooption = $("input[name='billto']:checked").val() ? $("input[name='billto']:checked").val() : 0;

            //{-- Grab company_id --}
            company_id = $("#comp_id").val();

            //{{-- Get the project data from the projcreateform fields... --}}
            var projArr = {                        
                user_id             : $("#user_id").val(), 
                projtype_id         : 1,                                                    //{{-- TODO:_LEGACY DEPRECATED, remove after full migration --}}
                tier_id             : 2,                                                    //{{-- TODO:_LEGACY DEPRECATED, remove after full migration --}}
                projstatus_id       : projstatus,
                projaccount_id      : projaccount,
                projbrand_id        : projbrand,
                projcampaign_id     : projcampaign,
                billtooption_id     : billtooption,
                description         : $("input[name='description']").val(),
                amount_site         : $("input[name='totalprice']").val() + "",             //{{-- totalprice is in Projects.create.blade - and convert to string --}}
                notes_user          : $("textarea[name='notes_user']").val(),
                person_responsible  : $("input[name='responsible']").val(),
                notification_email  : $("input[name='notification_email']").val(),
            }

            //{{-- Get the documents data to save. prepDocumentsCallback is back in create.blade --}}
            var docsArr = prepDocumentsCallback(pjc_DocArr, projstatus);

            //{{-- Now the AJAX post --}}
            $.ajax({
                url: pjc_route_job_store,                                                   //{{-- Route to JobsController's store method --}}
                method: "POST",                                                             //{{-- ... to send data to server --}}
                data:{ projArr: projArr, docsArr : docsArr, company_id : company_id },                                                         
                success:function(data) {
                    //{{-- if successful, the callback receives data, textStatus, jqXHR object --}}
                    //{{-- Show a confirmation message and then redirect to projets page when user closes message--}}
                    title = pjc_project_created;
                    message = pjc_thx_created;
                    popovermsgbox_open(title, message, 0, 'OK');
                    $('#popovermsgbox').safeOn('hidden.bs.modal', function () { 
                        $(window).off('beforeunload');                                          //{{-- Make sure we don't pester the user with messages about leaving  --}}
                        window.location.replace(pjc_route_root + '/projects/' + $("#user_id").val());
                    });                            
                },
                error:function(jqXHR1, textStatus, jqXHR2) {                            
                    //{{-- if failed, the callback function receives jqXHR object, textStatus, errorThrown --}}
                    if (jqXHR1.status >= 500 && jqXHR1.status <= 559 ) {
                        alert(pjc_err_saving_proj + "\n"
                            + pjc_err_nbr + jqXHR1.status + "\n"
                            + pjc_additional_info + jqXHR1.responseJSON.message 
                            );
                        $('#cancelProjectSaveBtn').trigger('click');                                      
                    } else {
                        //{{-- Insert the error messages in their proper places --}}
                        if (notThere(jqXHR1.responseText)) {
                            alert(pjc_err_saving_proj);
                        } else {
                            var errors = $.parseJSON(jqXHR1.responseText);                    
                            $.each(errors.errors, function(field, message) {                                
                                var fieldMsg = $('#' + field + '-error');
                                fieldMsg.html(message);                    
                            });    
                        }
                    }
                }                    
            });
        }
    }
}
